export default __webpack_public_path__ + "static/media/events.32f08b34.svg";